<template>
  <v-card>
    <v-card-title>プレビュー</v-card-title>
    <v-card-text>
      <v-switch
        v-model="withUnpublished"
        label="非公開画像を含めて表示"
      ></v-switch>
      <v-tabs style="margin-top: 15px">
        <v-tab>
          <v-icon>mdi-cellphone</v-icon>
        </v-tab>
        <v-tab>
          <v-icon>mdi-desktop-mac</v-icon>
        </v-tab>
        <v-tab-item>
          <div
            class="ma-auto"
            :style="{
              height: '600px',
              width: '310px',
              padding: '53px 26px 69px 28px',
              backgroundSize: 'contain',
              backgroundImage: `url(${require('/static/service/sp_preview.png')})`,
            }"
          >
            <div :style="{ overflowY: 'scroll', height: '100%' }">
              <template v-for="(galleryPerThree, index) in previewSpGallery">
                <div :key="index" style="display: flex">
                  <template v-if="index % 6 === 0">
                    <div style="width: 66%; padding: 1px">
                      <ExhibitBlockLayout
                        v-if='galleryPerThree[0]'
                        :src="galleryPerThree[0].file"
                        width="100%"
                        height="0"
                        paddingBottom="100%"
                      >
                        <span class="p-imageCard__priority--small">
                          {{ index * 3 + 1 }}
                        </span>
                      </ExhibitBlockLayout>
                    </div>
                    <div style="width: 33%">
                      <div style="padding: 1px">
                        <ExhibitBlockLayout
                          v-if='galleryPerThree[1]'
                          :src="galleryPerThree[1].file"
                          width="100%"
                          height="0"
                          paddingBottom="100%"
                        >
                          <span class="p-imageCard__priority--small">
                            {{ index * 3 + 2 }}
                          </span>
                        </ExhibitBlockLayout>
                      </div>
                      <div style="padding: 1px">
                        <ExhibitBlockLayout
                          v-if='galleryPerThree[2]'
                          :src="galleryPerThree[2].file"
                          width="100%"
                          height="0"
                          paddingBottom="100%"
                        >
                          <span class="p-imageCard__priority--small">
                            {{ index * 3 + 3 }}
                          </span>
                        </ExhibitBlockLayout>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="index % 6 === 3">
                    <div style="width: 33%">
                      <div style="padding: 1px">
                        <ExhibitBlockLayout
                          v-if='galleryPerThree[0]'
                          :src="galleryPerThree[0].file"
                          width="100%"
                          height="0"
                          paddingBottom="100%"
                        >
                          <span class="p-imageCard__priority--small">
                            {{ index * 3 + 1 }}
                          </span>
                        </ExhibitBlockLayout>
                      </div>
                      <div style="padding: 1px">
                        <ExhibitBlockLayout
                          v-if='galleryPerThree[2]'
                          :src="galleryPerThree[2].file"
                          width="100%"
                          height="0"
                          paddingBottom="100%"
                        >
                          <span class="p-imageCard__priority--small">
                            {{ index * 3 + 3 }}
                          </span>
                        </ExhibitBlockLayout>
                      </div>
                    </div>
                    <div style="width: 66%; padding: 1px">
                      <ExhibitBlockLayout
                        v-if='galleryPerThree[1]'
                        :src="galleryPerThree[1].file"
                        width="100%"
                        height="0"
                        paddingBottom="100%"
                      >
                        <span class="p-imageCard__priority--small">
                          {{ index * 3 + 2 }}
                        </span>
                      </ExhibitBlockLayout>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      v-for="(gallery, indexPerThree) in galleryPerThree"
                      :key="gallery.id"
                      style="width: 33%; padding: 1px"
                    >
                      <ExhibitBlockLayout
                        :src="gallery.file"
                        width="100%"
                        height="0"
                        paddingBottom="100%"
                      >
                        <span class="p-imageCard__priority--small">
                          {{ index * 3 + indexPerThree + 1 }}
                        </span>
                      </ExhibitBlockLayout>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div style="display: flex">
            <ExhibitBlockLayout
              v-if="previewGallery[0]"
              :src="previewGallery[0].file"
              width="40%"
              height="0"
              paddingBottom="40%"
            >
              <span class="p-imageCard__priority--small">1</span>
            </ExhibitBlockLayout>
            <div style="display: flex; flex-wrap: wrap; width: 60%">
              <div
                v-for="(gallery, index) in previewGallery.slice(1, 7)"
                :key="gallery.id"
                class="d-flex child-flex p-imageCard__handle"
                style="width: 33%; padding: 1px"
              >
                <ExhibitBlockLayout
                  :src="gallery.file"
                  width="100%"
                  height="0"
                  paddingBottom="100%"
                >
                  <span class="p-imageCard__priority--small">
                    {{ index + 2 }}
                  </span>
                </ExhibitBlockLayout>
              </div>
            </div>
          </div>
          <div style="display: flex; flex-wrap: wrap; width: 100%">
            <div
              v-for="(gallery, index) in previewGallery.slice(7)"
              :key="gallery.id"
              class="d-flex child-flex p-imageCard__handle"
              style="width: 20%; padding: 1px"
            >
              <ExhibitBlockLayout
                :src="gallery.file"
                width="100%"
                height="0"
                paddingBottom="100%"
              >
                <span class="p-imageCard__priority--small">
                  {{ index + 8 }}
                </span>
              </ExhibitBlockLayout>
            </div>
          </div>
        </v-tab-item>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
import ExhibitBlockLayout from '@/components/commons/exhibits/ExhibitBlockLayout'

export default {
  components: {
    ExhibitBlockLayout
  },
  props: {
    galleries: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      withUnpublished: false
    }
  },
  computed: {
    previewSpGallery () {
      const length = Math.ceil(this.previewGallery.length / 3)
      return new Array(length)
        .fill()
        .map((_, i) => this.previewGallery.slice(i * 3, (i + 1) * 3))
    },
    previewGallery () {
      if (this.withUnpublished) return this.galleries
      return this.galleries.filter((exhibit) => exhibit.published)
    }
  }
}
</script>

<style scoped>
.p-imageCard__priority--small {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 15px;
  height: 15px;
  line-height: 15px;
  font-size: 10px;
  text-align: center;
  background-color: #ddd;
  font-weight: bold;
}
</style>
